import { render } from "./PieceComponent.vue?vue&type=template&id=33c264bd&scoped=true"
import script from "./PieceComponent.vue?vue&type=script&lang=js"
export * from "./PieceComponent.vue?vue&type=script&lang=js"

import "./PieceComponent.vue?vue&type=style&index=0&id=33c264bd&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33c264bd"]])

export default __exports__